export default {
      id: "biochemical-usage",
      viewBox: "0 0 21 26",
      url: __webpack_public_path__ + "img/icons.svg#biochemical",
      toString: function () {
        return this.url;
      }
    }